import { createStyles } from '@mantine/styles';


export default createStyles((theme: {
    colors: { [x: string]: any[] };
    white: string;
    fontSizes: any;
    spacing: any;
    radius: any;
    fn: any;
    colorScheme: any;
}) => ({

    amenitiesList: {
        borderRadius: theme.radius.xs,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
        // borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
        // borderWidth: 1,
        // borderStyle: 'dashed',
    },

    amenitiesSpoiler: {
        '.mantine-Spoiler-control': {
            textTransform: 'uppercase',
            fontSize: 12,
            width: '100%',
            marginTop: 20,
            borderStyle: 'dashed',
            borderWidth: 1,
            borderRadius: theme.radius.xs,
            color: theme.colorScheme === 'light' ? theme.colors.dark[6] : theme.white,
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
            paddingTop: 10,
            paddingBottom: 10,
            ':hover': {
                textDecoration: 'none',
            },
        },
    },

}));
